import { styled } from '@mui/material/styles';

import { FONTS } from '../../shared/theme/typography';

/**
 * Sam's rule: every faked value on screen carries this. A small outlined pill,
 * so it reads as a label on the value rather than part of it.
 */
export const SampleMark = styled('span')({
  display: 'inline-block',
  marginLeft: 6,
  padding: '1px 6px',
  borderRadius: 999,
  border: '1px solid currentColor',
  fontFamily: FONTS.body,
  fontSize: 9.5,
  fontWeight: 700,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  lineHeight: 1.4,
  verticalAlign: 'middle',
  opacity: 0.75,
  whiteSpace: 'nowrap',
});
